import { ChangeEvent, memo } from "react";
import { useIntl } from "react-intl";

import { CustomCheckBox } from "../../../components/Inputs/CustomCheckBox";
import { PINNING_DEFAULT_VALUE } from "../../BannerEditor";

const PinningCheckbox = memo(
  ({
    defaultValue,
    onPinningChange,
  }: {
    defaultValue?: boolean;
    onPinningChange: (pinning: boolean) => void;
  }) => {
    const intl = useIntl();

    const handleChange = (_: ChangeEvent<HTMLInputElement>, value: boolean) => {
      onPinningChange(value);
    };

    return (
      <CustomCheckBox
        tooltip={intl.formatMessage(
          { id: "BANNER_PINNING_OPTION_TOOLTIP" },
          { br: <br /> }
        )}
        defaultValue={defaultValue ?? PINNING_DEFAULT_VALUE}
        label={intl.formatMessage({ id: "BANNER_PINNING_OPTION" })}
        onChange={handleChange}
        required={false}
      />
    );
  }
);

export default PinningCheckbox;
